export var Method;
(function (Method) {
    function is(value) {
        return (typeof value == "string" &&
            (value == "GET" ||
                value == "POST" ||
                value == "DELETE" ||
                value == "HEAD" ||
                value == "PATCH" ||
                value == "PUT" ||
                value == "OPTIONS" ||
                value == "TRACE" ||
                value == "CONNECT"));
    }
    Method.is = is;
    function parse(value) {
        value = value?.toUpperCase();
        return is(value) ? value : undefined;
    }
    Method.parse = parse;
})(Method || (Method = {}));
//# sourceMappingURL=Method.js.map